import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { getAllArtists } from "../../../api/artistApi";
import { getCountryMap, getStudio, getTermintypen } from "../../../api/commonApi";
import { loadArtistSettings } from "../../../api/localArtistPersistence";
import { saveUserReference } from "../../../api/localAuthPersistence";
import { getStudioSubscriptionStatus } from "../../../api/studioApi";
import { isPublicRoute, LOGIN_PATH } from "../../../config/publicRoutes";
import { selectIsLoggedIn, selectIsReadLocked, selectLoggedInArtistID, selectStudioUserID } from "../../auth/authSelector";
import { pushHistory } from "../../router/routerActions";
import { extractDataFromResponse } from "../../saga-utils/httpInterceptorWrapper";
import {
    LOAD_COMMON,
    loadCommonFailureAction,
    loadCommonSuccessAction,
    loadLoggedArtistSettingsSuccessAction
} from "../commonActions";
function* bootstrapCommon() {
    try {
        const isLoggedIn = yield select(state => selectIsLoggedIn(state))
        const isReadLocked = yield select(state => selectIsReadLocked(state))
        if (isLoggedIn && isReadLocked) {
            // A guest on an unknown device may not read before the device is unlocked. Every request would be
            // refused with 403. The app starts again (App.jsx) once the device is confirmed.
            return
        }
        if (isLoggedIn) {
            const artistID = yield select(state => selectLoggedInArtistID(state))
            const {
                artistSettings,
                countryMap,
                termintypMap,
                artistMap,
                studio,
                subscriptionStatus
            } = yield all({
                artistSettings: call(loadArtistSettings, artistID),
                countryMap: call(getCountryMap),
                termintypMap: call(getTermintypen),
                artistMap: call(getAllArtists),
                studio: call(getStudio),
                subscriptionStatus: call(getStudioSubscriptionStatus)
            })
            yield put(loadCommonSuccessAction({
                countryMap: extractDataFromResponse(countryMap)
                , artistMap: extractDataFromResponse(artistMap)
                , termintypMap: extractDataFromResponse(termintypMap)
                , studio: extractDataFromResponse(studio)
                , subscriptionStatus: extractDataFromResponse(subscriptionStatus)
            }))
            yield put(loadLoggedArtistSettingsSuccessAction(artistSettings))

            // Save user reference to localStorage to prevent accidental re-signup
            const userId = yield select(state => selectStudioUserID(state))
            if (userId) {
                yield call(saveUserReference, {userId})
            }


        } else {
            yield put(loadCommonFailureAction())
            // Check if we're on a public route that doesn't require authentication
            const currentPath = window.location.pathname
            
            // Only redirect to login if not on a public route
            if (!isPublicRoute(currentPath)) {
                yield put(pushHistory(LOGIN_PATH))
            }
        }

    } catch (e) {
        console.error('Loading the common data failed:', e?.response?.status, e?.message)
        yield put(loadCommonFailureAction())
        // Check if we're on a public route before redirecting to error page
        const currentPath = window.location.pathname
        
        // A refused refresh has already ended the session and sent the user to the login.
        const stillLoggedIn = yield select(state => selectIsLoggedIn(state))
        if (stillLoggedIn && !isPublicRoute(currentPath)) {
            yield put(pushHistory('/error'))
        }
    }
}

export function* watchLoadCommon() {
    yield takeLatest(LOAD_COMMON, bootstrapCommon)
}
